import React from 'react';
export const CFIconMenu = {
    alias: 'menu',
    defaultTitle: 'Menu',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M3.948 6h16.103c.522 0 .949.427.949.949v.102a.952.952 0 0 1-.949.949H3.948A.95.95 0 0 1 3 7.051v-.102A.95.95 0 0 1 3.948 6Zm16.103 5H3.948a.95.95 0 0 0-.948.949v.102a.95.95 0 0 0 .948.949h16.103a.952.952 0 0 0 .949-.949v-.102a.952.952 0 0 0-.949-.949Zm0 5H3.948a.95.95 0 0 0-.948.949v.102a.95.95 0 0 0 .948.949h16.103a.952.952 0 0 0 .949-.949v-.102a.952.952 0 0 0-.949-.949Z' }))),
};
